import React, { useState } from "react";
import { Auth } from "aws-amplify";
import { Space } from "antd";

import StartTotpSetup from "./StartTotpSetup";
import VerifyTotpSetup from "./VerifyTotpSetup";

type Props = {
  onSuccess: () => Promise<void> | void;
}

const TotpSetup = ({
  onSuccess,
}: Props) => {
  const [ secretCode, setSecretCode ] = useState("");
  const [ setupUri, setSetupUri ] = useState("");

  const getAccessToken = async () => {
    const user = await Auth.currentAuthenticatedUser();
    const { signInUserSession } = user;
    const { jwtToken } = signInUserSession.accessToken;

    return jwtToken;
  };

  const hasSetupData = secretCode.length > 0;

  return (
    <Space direction="vertical" size="large" style={{ width: "100%" }}>
      <StartTotpSetup
        hasSetupData={hasSetupData}
        getAccessToken={getAccessToken}
        onSetupData={(nextSecretCode, nextSetupUri) => {
          setSecretCode(nextSecretCode);
          setSetupUri(nextSetupUri);
        }}
      />

      {
        hasSetupData && (
          <VerifyTotpSetup
            setupUri={setupUri}
            onSuccess={onSuccess}
            secretCode={secretCode}
            getAccessToken={getAccessToken}
          />
        )
      }
    </Space>
  );
};

export default TotpSetup;
